import { render, staticRenderFns } from "./ModalListarVenda.vue?vue&type=template&id=1524f765"
import script from "./ModalListarVenda.vue?vue&type=script&lang=js"
export * from "./ModalListarVenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports